// import { styles } from "@material-ui/pickers/views/Calendar/Calendar";
import React, { useState } from "react";
import { ArrowLeft, ChevronDown, Plus } from "react-feather";
import styles from "./promptsListConversation.module.css";

const PromptsForConversation = ({ list, handlePromptClick, hanldePromptModal, hanldePromptModalForConversation, openPromptforConversation, openPromptforConversationHandler }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [openPrompt, setOpenPrompt] = useState(false);

  const OpenPrompt = () => {
    setOpenPrompt(!openPrompt);
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const filteredList = list.filter((item) => {
    const title = item?.title?.toLowerCase() || "";
    const description = item?.description?.toLowerCase() || "";
    return title.includes(searchTerm) || description.includes(searchTerm);
  });

  const promptHandler = (prompt) => {
    if (prompt) {
      handlePromptClick(prompt);
      openPromptforConversationHandler();
    }
  };

  return (<div className={!openPromptforConversation ? `${styles.PromptsList}` : `${styles.PromptsList} ${styles.Open}`}>
    {/* <button
        onClick={openPromptforConversationHandler}
        className={`${styles.PromptBU}`}
      >
        Prompts <ChevronDown />
      </button> */}
    <div className={`${styles.PromptListSec}`}>
      <div className={`${styles.PromptListHead}`}>
        <button className={`${styles.BackAddBU}`} onClick={openPromptforConversationHandler}>
          <ArrowLeft />
        </button>
        <input type="text" placeholder="Search prompt" onChange={handleInputChange} value={searchTerm} />
        {/* <button
            className={`${styles.AddPromptBU}`}
            onClick={() => hanldePromptModalForConversation(true)}
          >
            <Plus />
          </button> */}
      </div>
      <div className={`${styles.PromptListRow}`}>
        {filteredList.length > 0 ? (
          filteredList.map((l) => (<div key={l?.id} className={`${styles.PromptListCard}`} onClick={() => promptHandler(l?.description)}>
            <span className={`${styles.Title}`}>{l?.title}</span>
            <span className={`${styles.Text}`}>{l?.description}</span>
          </div>))
        ) : (<div className={`${styles.NoDataMain}`}>
          <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/no-prospect.png" alt="No Data" />
          </div>
          <p className={`${styles.NoDataText}`}>Let's get started!</p>
          <p className={`${styles.NoDataTextSub}`}>Your prompt list is empty.</p>
        </div>)}
      </div>
    </div>
  </div>);
};

export default PromptsForConversation;